import { useEffect } from 'react';

export interface UseClickOutsideParams {
  setShowWorkspaceDropdown: (show: boolean) => void;
  setShowModelDropdown: (show: boolean) => void;
  setShowExcludeModelsDropdown: (show: boolean) => void;
}

export function useClickOutside({
  setShowWorkspaceDropdown,
  setShowModelDropdown,
  setShowExcludeModelsDropdown,
}: UseClickOutsideParams): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('.workspace-dropdown')) {
        setShowWorkspaceDropdown(false);
      }
      if (!target.closest('.model-dropdown')) {
        setShowModelDropdown(false);
      }
      if (!target.closest('.exclude-models-dropdown')) {
        setShowExcludeModelsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowWorkspaceDropdown, setShowModelDropdown, setShowExcludeModelsDropdown]);
}
